import cn from 'classnames';
import { SimpleImage, TSimpleImageProps } from 'components/simple-image';
import { Button, Header, Spacer } from 'components/ui-kit';
import { Column, Container, Row } from 'components/ui-kit/grid';
import { Visibility } from 'components/ui-kit/visibility';
import { StaticImageData } from 'next/image';
import Link from 'next/link';
import catGifts from 'public/images/collaborations/utkonos/gifts.jpeg';
import catGiftsMob from 'public/images/collaborations/utkonos/gifts_mobile.jpeg';
import catNews from 'public/images/collaborations/utkonos/news.jpeg';
import catNewsMob from 'public/images/collaborations/utkonos/news_mobile.jpeg';
import { memo, type JSX } from 'react';
import styles from '../collaboration-utkonos-page.module.scss';

type Category = {
  url: string;
  img: StaticImageData;
  objectPosition?: TSimpleImageProps['objectPosition'];
  objectPositionMob?: TSimpleImageProps['objectPosition'];
  imgMobile: StaticImageData;
  title: string;
};

const categories: Array<Category> = [
  {
    url: '/new',
    img: catNews,
    imgMobile: catNewsMob,
    objectPositionMob: 'top',
    title: 'Новинки',
  },
  {
    url: '/products/gift',
    img: catGifts,
    imgMobile: catGiftsMob,
    title: 'Подарки',
  },
];

export const Categories = memo(function Categories(): JSX.Element {
  const renderHomepageCategory = (category: Category): JSX.Element => {
    const { title, img, imgMobile, url } = category;
    return (
      <Column key={title} span={{ s: 12, l: 6 }}>
        <Link className={cn(styles.category)} href={url}>
          <div className={styles.categoryImage}>
            <Visibility hidden="m" className="h-100">
              <SimpleImage
                alt=""
                src={imgMobile}
                layout="fill"
                objectFit="cover"
                placeholder="blur"
                objectPosition={category.objectPositionMob}
              />
            </Visibility>
            <Visibility visible="m" className="h-100">
              <SimpleImage
                alt=""
                src={img}
                layout="fill"
                objectFit="cover"
                placeholder="blur"
                objectPosition={category.objectPosition}
              />
            </Visibility>
          </div>
          <div className={styles.categoryText}>
            <Header
              color="white"
              level={2}
              weight="400"
              align="center"
              className={styles.categoryTitle}
            >
              {title}
            </Header>
            <Spacer size={32} />
            <Button size="l" variant="white" className={styles.categoryButton}>
              Подробнее
            </Button>
          </div>
        </Link>
      </Column>
    );
  };

  return (
    <Container isFluid>
      <Row className={styles.rowGap}>
        {categories.map(renderHomepageCategory)}
      </Row>
    </Container>
  );
});
